import { DrawerModalForm } from "../drawerModalForm";
import { Provider } from "../providerSection";
import { SelectServiceProviderForm } from "./selectServiceProviderForm";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onSelect: (providerId: string) => void;
  availableProviders: Provider[];
  selectedProviderId: string;
  serviceName: string;
};

export const SelectServiceProviderModal = ({
  isOpen,
  onClose,
  onSubmit,
  onSelect,
  availableProviders,
  selectedProviderId,
  serviceName,
}: Props) => {
  return (
    <DrawerModalForm
      open={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
      title="Change provider for service"
      description={`Providers available to perform ${serviceName} service:`}
      cancelButtonText="Cancel"
      confirmButtonText="Save changes"
      hideDivider
    >
      <SelectServiceProviderForm
        availableProviders={availableProviders}
        selectedProviderId={selectedProviderId}
        onSelect={onSelect}
      />
    </DrawerModalForm>
  );
};
